import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '../';

interface IconProps extends Partial<React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>> {
    /**
     * An optional width for the icon.
     */
    width?: string;

    /**
     * An optional height for the icon.
     */
    height?: string;

    /**
     * An optional tooltip to provide feedback to the user
     */
    tooltip?: string;

    /**
     * An optional placement of the tooltip
     */
    tooltipPreferredPlacement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';

    /**
     * An optional parameter to decide whether the icon is greyed out
     */
    disabled?: boolean;

    /**
     * An optional parameter to decide whether the icon is hidden
     */
    hidden?: boolean,
}

const StyleIconContainer = styled.div`
    display: ${props => props.theme.hidden ? 'none' : 'inline-block'};
    line-height: 0;
    width: ${props => props.theme.width ? props.theme.width : '100%'};
    height: ${props => props.theme.height ? props.theme.height : '100%'};
    & svg {
        fill: currentColor;
        width: 100%;
        height: 100%;
    }
`;

/**
 * Represents an icon with an optional tooltip.
 * @param props 
 */
export const Icon: React.FunctionComponent<IconProps> = (props) => {

    // "stylingClassName" is used for "styled components" extensions. It is hidden from the developer.
    const stylingClassName = (props as any).className ? (props as any).className : '';

    if (props.tooltip) {
        return (
            <Tooltip label={props.tooltip} preferredPlacement={props.tooltipPreferredPlacement}>
                <StyleIconContainer className={stylingClassName} theme={{ width: props.width, height: props.height, hidden: props.hidden }}>
                    {props.children}
                </StyleIconContainer>
            </Tooltip>
        );
    } else {
        return (
            <StyleIconContainer className={stylingClassName} theme={{ width: props.width, height: props.height, hidden: props.hidden }}>
                {props.children}
            </StyleIconContainer>
        );
    }
}